import React, { FunctionComponent, useMemo } from "react";
import TraitsContext, { TraitsContextValue } from "contexts/TraitsContext";
import useFetchTraits from "hooks/useFetchTraits";
import { Center } from "@chakra-ui/react";
import BoldSpinner from "components/BoldSpinner";
import useConnectedAccount from "hooks/useConnectedAccount";

type TraitsProviderProps = {};

const TraitsProvider: FunctionComponent<TraitsProviderProps> = ({
  children,
}) => {
  const [address] = useConnectedAccount();
  const [traits, fetch, isLoading] = useFetchTraits(address);

  const traitsByTokenId = useMemo(
    () =>
      traits?.reduce(
        (prev, trait) => ({
          ...prev,
          [trait.tokenId]: trait,
        }),
        {}
      ),
    [traits]
  );

  const contextValue = useMemo<TraitsContextValue>(
    () => ({
      traits: traits || [],
      traitsByTokenId: traitsByTokenId || {},
      fetchTraits: () => {
        fetch(address);
      },
      isLoading,
    }),
    [traits, traitsByTokenId, fetch, address, isLoading]
  );

  return (
    <TraitsContext.Provider value={contextValue}>
      {!traits ? (
        <Center h="100vh">
          <BoldSpinner size="xl" />
        </Center>
      ) : (
        children
      )}
    </TraitsContext.Provider>
  );
};

export default TraitsProvider;
